import { initNav } from '../components/nav';

initNav();

const copyBtn = document.getElementById('copy-email-btn') as HTMLButtonElement | null;
const copyText = document.getElementById('copy-btn-text');
const toastEl = document.getElementById('contact-toast');

const EMAIL = 'alejandrocanales@chessmechanic.com';

function showToast(message: string): void {
  if (!toastEl) return;
  toastEl.textContent = message;
  toastEl.classList.add('show');
  setTimeout(() => {
    toastEl.classList.remove('show');
  }, 2200);
}

copyBtn?.addEventListener('click', async () => {
  try {
    await navigator.clipboard.writeText(EMAIL);

    if (copyText) copyText.textContent = 'Copied!';
    showToast('Email address copied to clipboard');

    setTimeout(() => {
      if (copyText) copyText.textContent = 'Copy';
    }, 2000);
  } catch {
    // Fallback for browsers with strict clipboard permissions
    window.location.href = `mailto:${EMAIL}`;
  }
});

// --- Coaching Inquiry Form ---
const contactForm = document.getElementById('contact-form') as HTMLFormElement | null;
const formStatusEl = document.getElementById('contact-form-status');
const submitBtn = document.getElementById('contact-submit-btn') as HTMLButtonElement | null;
const startedAtInput = document.getElementById('cf-started-at') as HTMLInputElement | null;

// Record when the form was rendered for the server-side time gate
if (startedAtInput) {
  startedAtInput.value = String(Date.now());
}

function showFormStatus(message: string, isError = true): void {
  if (!formStatusEl) return;
  formStatusEl.textContent = message;
  formStatusEl.classList.toggle('error', isError);
}

function setSubmitLoading(loading: boolean): void {
  if (!submitBtn) return;
  submitBtn.disabled = loading;
  submitBtn.style.opacity = loading ? '0.7' : '';
  const textSpan = submitBtn.querySelector('span');
  if (textSpan) {
    textSpan.textContent = loading ? 'Sending...' : 'Send Inquiry';
  }
}

contactForm?.addEventListener('submit', async (e) => {
  e.preventDefault();
  showFormStatus('');

  const payload = {
    name: (document.getElementById('cf-name') as HTMLInputElement | null)?.value.trim() || '',
    email: (document.getElementById('cf-email') as HTMLInputElement | null)?.value.trim() || '',
    rating: (document.getElementById('cf-rating') as HTMLInputElement | null)?.value.trim() || '',
    goal: (document.getElementById('cf-goal') as HTMLInputElement | null)?.value.trim() || '',
    frustration: (document.getElementById('cf-frustration') as HTMLTextAreaElement | null)?.value.trim() || '',
    website: (document.getElementById('cf-website') as HTMLInputElement | null)?.value || '',
    startedAt: Number(startedAtInput?.value || '0'),
  };

  if (!payload.name || !payload.email || !payload.rating || !payload.goal || !payload.frustration) {
    showFormStatus('Please fill in all fields.');
    return;
  }

  setSubmitLoading(true);

  try {
    const res = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      showFormStatus(data.error || 'Unable to send your inquiry. Please email me directly.');
      setSubmitLoading(false);
      return;
    }

    showFormStatus('Inquiry sent! I will get back to you soon.', false);
    showToast('Inquiry sent!');
    contactForm?.reset();
    setSubmitLoading(false);
  } catch {
    showFormStatus('Unable to reach the server. Please email me directly.');
    setSubmitLoading(false);
  }
});